import React from 'react';

import type { AvailableIconName } from '@/assets/icons';
import { Stack } from '@/components/layout';
import { SvgIcon, Switch, Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

type NotificationPreferenceRowProps = {
  icon: AvailableIconName;
  title: string;
  subtitle: string;
  value: boolean;
  onValueChange: (value: boolean) => void;
};

export function NotificationPreferenceRow({
  icon,
  title,
  subtitle,
  value,
  onValueChange,
}: NotificationPreferenceRowProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Stack direction="row" align="center" gap={scale(10)} style={styles.row}>
      <Stack align="center" justify="center" style={styles.iconTile}>
        <SvgIcon name={icon} size={scale(24)} color={guardianColors['Main/Main']} />
      </Stack>
      <Stack flex={1} minWidth={0}>
        <Text
          variant="Font Guardian App/Subtitle/Subtitle 14 Bold"
          numberOfLines={2}
          style={styles.title}>
          {title}
        </Text>
        <Text
          variant="Font Guardian App/Subtitle/Subtitle 12 Regular"
          numberOfLines={2}
          style={styles.subtitle}>
          {subtitle}
        </Text>
      </Stack>
      <Switch value={value} onValueChange={onValueChange} />
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  row: {
    paddingLeft: scale(12),
    paddingRight: scale(16),
    paddingVertical: scale(10),
  },
  iconTile: {
    width: scale(40),
    height: scale(40),
    borderRadius: scale(8),
    borderCurve: 'continuous',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: guardianColors['Main/10'],
    borderWidth: scale(1),
    borderColor: colors['1'],
  },
  title: {
    color: guardianColors['Main/Main'],
  },
  subtitle: {
    color: guardianColors['6'],
  },
}));
